import styled, { css } from 'styled-components';
import Input from '../../../components/Input';
import DropdownInput from '../../../components/DropdownInput';

// export const BankAccountForm = styled.form``;
export const BeneficiaryInformationDiv = styled.div`
  /* display: flex;
  align-items: flex-start;
  justify-content: flex-start; */
`;

export const SectionWrapperDiv = styled.div`
  @media screen and (min-width: 1024px) {
    display: flex;
  }
`;

export const Section = styled.section`
  @media screen and (min-width: 1024px) {
    ${props =>
      props.right &&
      css`
        margin-left: 6rem;
      `}
  }
`;

export const AccountInformationDiv = styled.div`
  margin-top: 4.5rem;
`;

export const TitleH3 = styled.h3`
  padding-bottom: 0.8rem;
  border-bottom: 1px solid ${props => props.theme.mercury};
`;

export const BankAccountInput = styled(Input)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    width: 271px;
  }
`;

export const VoidChequeDiv = styled.div`
  margin-top: 4.5rem;
  max-width: 604px;
`;

export const BankAccountDropdownInput = styled(DropdownInput)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    width: 271px;
  }
`;
